export default "__VITE_ASSET__76ce92f0__"